import Color from 'color'

export function calcOpacityColor(hexColor: string, opacity: number) {
  return Color(hexColor)
    .mix(Color('white'), 1 - opacity)
    .hex()
}
